<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">Nominations</h2>
        <h2 v-show="trash">Nominations - Trash</h2>
      </b-col>
      <!--Gear Icon-->
      <b-col lg="6">
        <b-btn class="pull-right" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn>
      </b-col>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid targets>
            <!-- Main table element -->
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                <!--        <span class="input-group-text" id="basic-addon1">Filter</span> -->
                      <b-form-input v-model="filter" placeholder="Search" />
                      <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
               <!--       <b-btn v-b-popover.hover.top="'Reload Table!'" variant="success" @click="reload"><i class="fa fa-refresh"></i></b-btn> -->
                    </div>
                  </div>
              </b-col>

              <b-col lg="3" class="my-1">
                <b-dropdown id="ddown1" :text="dpdt">
                  <b-dropdown-item @click="trashTarget()">Active</b-dropdown-item>
                  <b-dropdown-item @click="trashTarget()">Trash</b-dropdown-item>
                </b-dropdown>
              </b-col>

              <b-col lg="5" class="my-1">
                <b-button variant="primary" class="pull-right" @click="newTargetModal()">Add Nomination</b-button>
              </b-col>
            </b-row>
            <b-row v-if="loadingData">
                    <b-col cols="12" sm="12" md="12" lg="12">
                       <p class="text-center">
                         <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                       </p>
                    </b-col>
            </b-row>
            <!-- End Main table Elements-->

            <b-table striped hover v-else bordered show-empty
                     stacked="md"
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
                     @row-clicked="rowClicked"
            >
            <template slot="actions" slot-scope="row">
              <b-button size="sm" @click.stop="newTargetModal(row)">
								Clone
							</b-button>
            </template>
            </b-table>
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"> </div>
                    <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
            <!--  Interface controls -->
              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New EModal-->
    <b-modal title="New Nomination" v-model="newTargets" ok-only ok-title="Cancel" ok-variant = "secundary">
      <b-row>
        <b-col cols="12">
            <b-form-group v-show="view" :label-cols="4" horizontal label="Energy Company" label-for="target0">
							<b-form-select id="target0" v-model="model.energy_company_id" :options="energycompanies" @input="select_energy_companies"/>
						</b-form-group>
          <!--  <b-form-group :label-cols="4" horizontal label="Fluid Type" label-for="Grouptarget2">
							<b-form-select :disabled="fluids.length == 0" id="Grouptarget2" v-model="model.fluid_type_id" :options="fluids"/>
						</b-form-group>-->
            <b-form-group v-if="fluids.length > 0" :label-cols="4" id="L2" label="Fluid Types" label-for="Grouptarget2" horizontal>
              <b-form-checkbox-group class="custom-checkboxes" :options="fluids" name="Checkboxes2" plain v-model="model.fluid_type_ids" @input="FTChange"></b-form-checkbox-group>
              <b-form-checkbox style="margin-top: 15px;" v-model="ftAllSelected" :indeterminate="indeterminateFT" aria-describedby="" aria-controls="" plain @change="FTToggleAll">
                {{ ftAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </b-form-group>


            <b-form-group :label-cols="4" horizontal label="Unload Location" label-for="Grouptarget1">
							<b-form-select :disabled="locations.length == 0" id="Grouptarget1" v-model="model.location_id" :options="locations"/>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="Initial Date" label-for="initial_date">
							<b-form-input id="initial_date" v-model="model.initial_date" type="date"></b-form-input>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="End Date" label-for="end_date">
							<b-form-input id="end_date" v-model="model.end_date" type="date"></b-form-input>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="Volume" label-for="target5">
							<b-form-input placeholder="0.00" id="target5" v-model="model.volume" @keydown.native="myOnlyNumber($event, 'volume')" @blur.native="inputBlur('volume')" ></b-form-input>
						</b-form-group>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newTargets=false" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveTargets()" class="float-right">Save</b-btn>
      </div>
    </b-modal>
    <!-- End New  Modal-->
        <!-- Table Config-->
      <b-modal title="Config Table" v-model="configTable" ok-variant = "primary">
        <b-row>
          <b-col cols="12">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
                <b-form-checkbox value="energy_company_name" :disabled="true" @change="actionField('energy_company_name')">Energy Company Name</b-form-checkbox>
                <b-form-checkbox value="location_name" :disabled="true" @change="actionField('location_name')">Location Name</b-form-checkbox>
                <b-form-checkbox value="fluid_type_name" :disabled="true" @change="actionField('fluid_type_name')">Fluid Type Name</b-form-checkbox>
                <b-form-checkbox value="initial_date" :disabled="true" @change="actionField('initial_date')">Initial Date</b-form-checkbox>
                <b-form-checkbox value="end_date" :disabled="true" @change="actionField('end_date')">End Date</b-form-checkbox>
                <b-form-checkbox value="volume" :disabled="true" @change="actionField('volume')">Volume</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-modal>
      <!-- Table Config-->
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import targets from './targets'
  import ec_service from '../energy_companies/ec_service'
  import locations_service from '../locations/locations_service'
  import moment from 'moment';

  Vue.use(VueSweetalert2)

  const items = []
  import axios from 'axios'
  import {apiDomain} from '../../config'

  export default {
    name: 'targets',
    created: function () {
      this.getAll()
      localStorage.removeItem("haulsaPage");
      localStorage.removeItem("targetsaPage");
      localStorage.removeItem("ftPage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tpPage");
			localStorage.removeItem("oasaPage");
			localStorage.removeItem("oaPage");
			localStorage.removeItem("reportPage");
			localStorage.removeItem("rolesPage");
			localStorage.removeItem("servicePage");
			localStorage.removeItem("tasaPage");
			localStorage.removeItem("tcPage");
			localStorage.removeItem("locationPage");
      localStorage.removeItem("truckPage");
      localStorage.removeItem("userPage");
      if (!localStorage.targetPage) {
          localStorage.targetPage = 0;
      }
    },
    data () {
      return {
        trash: false,
        dpdt: "Active",
        newTargets: false,
        loadingData: true,
        configTable: false,
        selectedItems: ['energy_company_name','location_name','fluid_type_name','initial_date','end_date','volume'],
        items: items,
        fields: [
          { key: 'id', label: 'ID', sortable: true },
          { key: 'energy_company_name', label: 'Energy Company', sortable: true },
          { key: 'location_name', label: 'Unload Location', sortable: true },
          //{ key: 'fluid_type_name', label: 'Fluid Type', sortable: true },
          { key: 'initial_date', label: 'Initial Date', sortable: true, formatter: (value) => { return moment(value).format("MMM DD, YYYY") } },
          { key: 'end_date', label: 'End Date', sortable: true, formatter: (value) => { return moment(value).format("MMM DD, YYYY") }},
          { key: 'volume', label: 'Volume', sortable: true},
          { key: 'actions', label: 'Actions', sortable: false},
        ],
        currentPage: parseInt(localStorage.targetPage),
        perPage: 25,
        totalRows: items.length,
        pageOptions: [ 25, 50, 100],
        sortBy: 'initial_date',
        sortDesc: false,
        filter: null,
        modalInfo: { title: '', content: '' },
        modalEdit: { title: ''},

        fluids: [],
        locations: [],
        energycompanies: [],

        model: {
          id                :null,
          energy_company_id : '',
          location_id       : '',
          fluid_type_ids    : [],
          initial_date      :'',
          end_date          : '',
          volume            : ''
        },
				role:'',
				view:true,
				savebtn:true,
        energy_company_id :null,        
        indeterminateFT: false,
				ftAllSelected: false,

      }
    },
    computed: {
      sortOptions () {
        return this.fields
          .filter(f => f.sortable)
          .map(f => { return { text: f.label, value: f.key } })
      }
    },
    methods: {
      FTChange() {
        console.log(this.model.fluid_type_ids)
				if (this.model.fluid_type_ids.length === 0) {
					this.indeterminateFT = false
					this.ftAllSelected = false
				} else if (this.model.fluid_type_ids.length === this.fluids.length) {
					this.indeterminateFT = false
					this.ftAllSelected = true
				} else {
					this.indeterminateFT = true
					this.ftAllSelected = false
				}
			},
      FTToggleAll(checked) {
				this.model.fluid_type_ids = checked ? this.fluids.map(item => {
					return item.value
				}) : []
      },
      trashTarget() {
        this.trash = !this.trash
        this.dpdt = this.trash ? "Trash" : "Active"
        this.getAll()
        this.loadingData = true
      },
      inputBlur(variableName) {
        let variableValue = this.model[variableName]
        if (variableValue.length == 0) {
          this.model[variableName] = "0.00"
        } else {
          let tempValue = variableValue.split(".")
          if (tempValue.length == 1) {
            this.model[variableName] = String(variableValue) + ".00"
          } else if (tempValue.length == 2) {
            this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
          }
        }
      },
      myOnlyNumber(evt, variableName) {
        let dotPosition = this.model[variableName].indexOf(".")
        let hasDot = dotPosition > -1
        let length = this.model[variableName].length
        this.isNumber(evt, hasDot, dotPosition, length)
      },
      isNumber: function(evt, hasDot, dotPosition, length) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
          let selectionStart = evt.target.selectionStart;
          let selectionEnd = evt.target.selectionEnd;
          if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
            evt.preventDefault();
          } else {
            return true
          }
        } else {
          evt.preventDefault();
        }
      },
      select_energy_companies() {
        if (this.role =='super_admin') {
        this.fluids = []
        this.model.fluid_type_ids = []

        let energycompanies = this.insertData.energy_companies
        let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
        if (energy_company_index > -1) {
          let fluid_types = energycompanies[energy_company_index].fluid_types
          this.fluids = fluid_types.map(item => {
											return { 'value': item.id, 'text': item.name }
          })
       //   if (this.fluids.length == 1) {
         //   this.model.fluid_type_ids = this.fluids[0].value
         // }
          console.log(this.fluids)
        }
        }
      },
      rowClicked(row) {
        localStorage.targetPage = this.currentPage;
        if(!this.trash) {
          this.$router.push('/target/'+row.id+'/')
        } else {
          this.restoreTarget(row.id)
        }
      },
      newTargetModal(row) {
        if(row) // Clone data from selected row
        {
            var datei = new Date(row.item.initial_date + 'T00:00:00')
            var firstDay = new Date(datei.getFullYear(), datei.getMonth() + 1, 1)
            var lastDay = new Date(datei.getFullYear(), datei.getMonth() + 2, 0)
            this.model = {
            energy_company_id : row.item.energy_company_id,
            location_id : row.item.location_id,
            fluid_type_ids    : [],
            //fluid_type_id : row.item.fluid_type_id,
            initial_date : moment(firstDay).format("YYYY-MM-DD"),
            end_date : moment(lastDay).format("YYYY-MM-DD"),
            volume : row.item.volume.replace(',','').replace('m³','')
          }
        }
        else{
            this.model = {
            energy_company_id : '',
            location_id : '',
            fluid_type_ids    : [],
            initial_date :'',
            end_date : '',
            volume : ''
          }
        }
        this.indeterminateFT  = false
				this.ftAllSelected    = false 
        this.newTargets       = true
        this.savebtn          =false
      },
      onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.currentPage = parseInt(localStorage.targetPage)
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      okToSave() {
					if (this.role =='super_admin') {
						if(this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0 ) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
						}
					}
        if (this.model.fluid_type_ids === undefined || this.model.fluid_type_ids.length == 0) {
          this.$swal('Alert!', 'Fluid Types not selected', 'warning')
          return false
        } else if (this.model.location_id === undefined || this.model.location_id.length == 0) {
          this.$swal('Alert!', 'Unload Location not selected', 'warning')
          return false
        } else if (this.model.volume === undefined || this.model.volume.length == 0) {
          this.$swal('Alert!', 'Water Actual can not be empty', 'warning')
          return false
        }

        try {
          let startDateValidation = (new Date(this.model.initial_date)).getFullYear()
          if(startDateValidation <= 2000 || startDateValidation >= 2100 || isNaN(startDateValidation)) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'Initial Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        try {
          let endDateValidation = (new Date(this.model.end_date)).getFullYear()
          if(endDateValidation <= 2000 || endDateValidation >= 2100 || isNaN(endDateValidation)) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        return true
      },
      saveTargets () {
        this.inputBlur('volume')

        if (!this.okToSave()) {
          return
        }

				this.savebtn=true
				if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
					this.model.energy_company_id = this.energy_company_id
				}
        let model = {
          location_id       : this.model.location_id,
          fluid_type_id     : this.model.fluid_type_ids,
          energy_company_id : this.model.energy_company_id,
          initial_date      : this.model.initial_date,
          end_date          : this.model.end_date,
          volume            : parseFloat(parseFloat(this.model.volume).toFixed(2))
        }

        targets.save(model)
          .then(data => {
            Vue.swal(data[0], data[1], data[0])
            if (data[0] == 'success') {
              this.newTargets = false
              this.getAll()
            }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
        this.savebtn=false
      },
      getAll () {
        this.loadingData = true
        targets.getAll()
          .then(data => {
            if (data[0] == 'success') {
              this.items = data[1].filter(o => o.status_id == (this.trash ? 2 : 1))
              this.insertData = data[2]
              this.locations = this.insertData.unloads_locations.map(item => {
                      return { 'value': item.id, 'text': item.name }
              })
              if (this.locations.length == 1) {
                this.model.location_id = this.locations[0].value
              } else {
                this.model.location_id = ''
              }

							this.role = data[3]
              if (this.role =='super_admin') {
                  this.view=true
									this.energycompanies = this.insertData.energy_companies.map(item => {
                      return { 'value': item.id, 'text': item.company_name }
											//return { text: item.name, value: item.id }
									})
              } else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
									this.view=false
									this.energy_company_id = data[4]
									let fluid_types = this.insertData.energy_companies[0].fluid_types
                  this.fluids = fluid_types.map(item => {
											return { 'value': item.id, 'text': item.name }
                  })
                  this.model.fluid_type_ids = []
							}


            } else {
              this.items = []
              this.$swal(data[0], data[1], data[0])
            }
            this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      restoreTarget(id) {
        Vue.swal({
          title: 'Please, confirm',
          text: "Are you sure to restore this Target?",
          type: 'question',
          showCancelButton: true,
          cancelButtonColor: '#a1a5a7',
          confirmButtonColor: '#ffce00',
          confirmButtonText: 'Yes',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            targets.restore(id)
              .then(data => {
                Vue.swal(data[0], data[1], data[0])
                if (data[0] == 'success') {
                  this.filter = ''
                  this.trash = false
                  this.getAll()
                  this.loadingData = true
                }
              })
              .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
              })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/m_targets/m_targets.vue